import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import { IMaskInput } from "react-imask";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadEmpresa() {
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodempresa, setedtcodempresa] = useState(0);
  const [edtrazaosocial, setedtrazaosocial] = useState("");
  const [edtnomefantasia, setedtnomefantasia] = useState("");
  const [edtcnpj, setedtcnpj] = useState("");
  const [edtcep, setedtcep] = useState("");
  const [edtendereco, setedtendereco] = useState("");
  const [edtnumero, setedtnumero] = useState("");
  const [edtcomplemento, setedtcomplemento] = useState("");
  const [edtbairro, setedtbairro] = useState("");
  const [edtcidade, setedtcidade] = useState("");
  const [edttelefone, setedttelefone] = useState("");
  const [edtwhatsapp, setedtwhatsapp] = useState("");
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodempresa(cad.codempresa);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      ExcluirCad();
      setIsOpenMotivoExclusao(false);
      ListarEmpresa();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarEmpresa() {
    api
      .get("v1/cadastro/empresa", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/empresa",
        {
          razaosocial: edtrazaosocial,
          nomefantasia: edtnomefantasia,
          cnpj: edtcnpj,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          ativo: edtativo,
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setabusca("a");
        setabusca("");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/empresa",
        {
          codempresa: edtcodempresa,
          razaosocial: edtrazaosocial,
          nomefantasia: edtnomefantasia,
          cnpj: edtcnpj,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarEmpresa();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/empresa", {
        params: {
          codempresa: edtcodempresa,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarEmpresa();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function ExcluirCad(cad) {
    setedtcodempresa(cad.codempresa);
    Excluir();
  }

  useEffect(
    function () {
      ListarEmpresa();
    },
    [showform, abusca, handleConfirma]
  );

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodempresa(0);
    setedtrazaosocial("");
    setedtnomefantasia("");
    setedtcnpj("");
    setedtcep("");
    setedtendereco("");
    setedtnumero("");
    setedtcomplemento("");
    setedtbairro("");
    setedtcidade("");
    setedttelefone("");
    setedtwhatsapp("");
    setedtativo("S");
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodempresa(cad.codempresa);
    setedtrazaosocial(cad.razaosocial);
    setedtnomefantasia(cad.nomefantasia);
    setedtcnpj(cad.cnpj);
    setedtcep(cad.cep);
    setedtendereco(cad.endereco);
    setedtnumero(cad.numero);
    setedtcomplemento(cad.complemento);
    setedtbairro(cad.bairro);
    setedtcidade(cad.cidade);
    setedttelefone(cad.telefone);
    setedtwhatsapp(cad.whatsapp);
    setedtativo(cad.ativo);
  }  

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
        <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                <h2>Novo Cadastro</h2>
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-5">
                      <label htmlFor="razaosocial" className="form-label">
                        Razão Social
                      </label>
                      <input
                        type="text"
                        id="razaosocial"
                        className="form-control"
                        placeholder="Razão Social"
                        value={edtrazaosocial}
                        onChange={(e) => setedtrazaosocial(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-5">
                      <label htmlFor="nomefantasia" className="form-label">
                        Nome Fantasia
                      </label>
                      <input
                        type="text"
                        id="nomefantasia"
                        className="form-control"
                        placeholder="Nome Fantasia"
                        value={edtnomefantasia}
                        onChange={(e) => setedtnomefantasia(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-2">
                      <label htmlFor="cnpj" className="form-label">
                        CNPJ
                      </label>
                      <IMaskInput
                        mask={"00.000.000/0000-00"}
                        radix="."
                        id="cnpj"
                        className="form-control"
                        placeholder="CNPJ"
                        value={edtcnpj}
                        onAccept={(value) => setedtcnpj(value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="cep" className="form-label">
                        CEP
                      </label>
                      <IMaskInput
                        mask={"00000-000"}
                        radix="."
                        id="cep"
                        className="form-control"
                        placeholder="CEP"
                        value={edtcep}
                        onAccept={(value) => setedtcep(value)}
                      />
                    </div>

                    <div className="col-sm-7">
                      <label htmlFor="endereco" className="form-label">
                        Endereço
                      </label>
                      <input
                        type="text"
                        id="endereco"
                        className="form-control"
                        placeholder="Endereço"
                        value={edtendereco}
                        onChange={(e) => setedtendereco(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-2">
                      <label htmlFor="numero" className="form-label">
                        Número
                      </label>
                      <input
                        type="text"
                        id="numero"
                        className="form-control"
                        placeholder="Número"
                        value={edtnumero}
                        onChange={(e) => setedtnumero(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="complemento" className="form-label">
                        Complemento
                      </label>
                      <input
                        type="text"
                        id="complemento"
                        className="form-control"
                        placeholder="Complemento"
                        value={edtcomplemento}
                        onChange={(e) => setedtcomplemento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="bairro" className="form-label">
                        Bairro
                      </label>
                      <input
                        type="text"
                        id="bairro"
                        className="form-control"
                        placeholder="Bairro"
                        value={edtbairro}
                        onChange={(e) => setedtbairro(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="cidade" className="form-label">
                        Cidade
                      </label>
                      <input
                        type="text"
                        id="cidade"
                        className="form-control"
                        placeholder="Cidade"
                        value={edtcidade}
                        onChange={(e) => setedtcidade(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="telefone" className="form-label">
                        Telefone
                      </label>
                      <IMaskInput
                        mask={"(00) 0 0000-0000"}
                        radix="."
                        id="telefone"
                        className="form-control"
                        placeholder="Telefone"
                        value={edttelefone}
                        onAccept={(value) => setedttelefone(value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="whatsapp" className="form-label">
                        WhatsApp
                      </label>
                      <IMaskInput
                        mask={"(00) 0 0000-0000"}
                        radix="."                        
                        id="whatsapp"
                        className="form-control"
                        placeholder="WhatsApp"
                        value={edtwhatsapp}
                        onAccept={(value) => setedtwhatsapp(value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label" htmlfor="ativo2">
                            Não
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Empresas</h1>
          <p className="ms-4">Rotina para cadastrar empresas e filiais</p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, razão social, nome fantasia ou cnpj"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/empresa")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Razão Social</th>
                <th className="fantasia">Nome Fantasia</th>
                <th className="cnpj">CNPJ</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codempresa}>
                    <th>{item.codempresa}</th>
                    <th>{item.razaosocial}</th>
                    <th>{item.nomefantasia}</th>
                    <th>{item.cnpj}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/empresa")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/empresa")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadEmpresa;
